export enum EventType {
  trackEvent = 'trackEvent',
  functionalityEvent = 'functionalityEvent',
  exceptionEvent = 'exceptionEvent',
}
